import './App.css';
import { useState } from 'react';
import Home from './pages/Home/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Pricing from './pages/Pricing/Pricing';
import About from './pages/About/About';
import Navbar from './components/Navbar/Navbar';
import Contact from './pages/Contact/Contact';
import Policy from './pages/Policy/Policy';
import FAQs from './pages/FAQ/FAQs';
import Terms from './pages/Terms/Terms';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { useEffect } from 'react';
import Cookies from 'js-cookie'

function App() {
  const [loading, setLoading] = useState(true);
  const [askCooki,setAskCooki] = useState(false)
  const [cookiShow,setCookiShow] = useState(true)

  const container = document.querySelector('.center');

  if (container) {
    setTimeout(() => {
      container.style.display = 'none';
      setLoading(false);
    }, 2000);
  }

  useEffect(()=>{
    if(Cookies.get('cookies') == 'true'){
      setAskCooki(false)
    }
      else{
        setAskCooki(true)
    }
  },[])



  const acceptCookies = () =>{
      Cookies.set('cookies', 'true', { expires: 365 })
      setCookiShow(false)
  }

  const declineCookies = () => {
    setCookiShow(false)
  }

  
  
  // let statusBarColor = "#FDFBF9";

  // function checkRoute() {
  //   document.getElementsByTagName("META")[2].content = statusBarColor;

  //   let thisUrl = window.location.href;

  //   if (thisUrl.includes("about")) {
  //     statusBarColor = "#121212";
  //   } else if (!thisUrl.includes("about")) {
  //     statusBarColor = "#FDFBF9";
  //   }
  // }

  // useEffect(() => {
  //   setInterval(checkRoute, 10);
  // }, []);

  return (
    !loading && (
      <div className='App'>
        <Router>
          <ScrollToTop>
            <Navbar />
            <Routes>
              <Route exact path='/' element={<Home />} />
              <Route path='/pricing' element={<Pricing />} />
              <Route path='/about' element={<About />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/policy' element={<Policy />} />
              <Route path='/faqs' element={<FAQs />} />
              <Route path='/terms' element={<Terms />} />
            </Routes>
          </ScrollToTop>
        </Router>


      {askCooki && (
        <div className="cookie-container slide-in-bottom " style = {{ animationName: cookiShow ? '' : 'removeCooki', animationDelay: cookiShow ? '3s' : '0s'}}>
          <div className="cookie-cookie">
            <img src="./assets/cookie.svg" alt="" />
          </div>
          <div className="cookie-text">
          We use cookies to personalize your site experience and analyze the traffic
          </div>
          <div className="cookie-buttons">
            <div className="cookie-decline" onClick={declineCookies}>
              Decline
            </div>
            <div className="cookie-accept" onClick={acceptCookies}>
              Accept
            </div>
          </div>
        </div>
      )}
        
       
      </div>
    )
  );
}

export default App;
